import theme from '@styles/theme';

export const CloudUpload = ({
  width = 44,
  height = 44,
  stroke = theme.palette.primary[0],
}: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 44 44'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M27.5 27.5L22 22'
        stroke={stroke}
        strokeWidth='2.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22 22L16.5 27.5'
        stroke={stroke}
        strokeWidth='2.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.0007 36.6667V22'
        stroke={stroke}
        strokeWidth='2.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.666 34.834H10.9993C6.94926 34.834 3.66602 31.5507 3.66602 27.5007C3.66602 23.4506 6.94926 20.1673 10.9993 20.1673L10.981 20.0383C10.5247 16.8442 11.477 13.6092 13.591 11.1717C15.705 8.73419 18.7728 7.33401 21.9993 7.33398C25.2259 7.33401 28.2937 8.73419 30.4077 11.1717C32.5217 13.6092 33.474 16.8442 33.0177 20.0383L32.9993 20.1673C37.0494 20.1673 40.3327 23.4506 40.3327 27.5007C40.3327 31.5507 37.0494 34.834 32.9993 34.834H29.3327'
        stroke={stroke}
        strokeWidth='2.7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
